import { push, replace } from 'redux-first-history';

import { store } from '~redux/store';
import { NavigationConstants } from '~utils/constants';

const {
    homePage,
    loginPage,
} = NavigationConstants;

const navPush = (routeName: string) => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
    });

    store.dispatch(push(routeName));
};

const navReplace = (routeName: string) => {
    store.dispatch(replace(routeName));
};

const navResetToLogin = (): void => {
    navReplace(loginPage);
};

const navToLogin = (): void => {
    navPush(loginPage);
};

const navToHome = (): void => {
    navPush(homePage);
};

const navResetToHome = (): void => {
    navReplace(homePage);
};

export default {
    navToLogin,
    navResetToLogin,
    navToHome,
    navResetToHome,
};
